import { Box, TableCell } from '@mui/material';
import { Tooltip } from '@agronod/mui-components';
import { intervallText, RevisionKolumn } from '../../utils/api';

/**
 * Kolumnrubrik för ett mått: namn, enhet och förväntat intervall som pill.
 * Delas av revisionens tabeller.
 */
export const MattRubrik = ({ kolumn }: { kolumn: RevisionKolumn }) => (
  <TableCell align="center" sx={{ verticalAlign: 'bottom', minWidth: 96, px: 0.75 }}>
    <Tooltip
      title={`${kolumn.visningsnamn} (${kolumn.typ === 'kontrollpunkt' ? 'kontrollpunkt' : 'nyckeltal'})`}
    >
      <Box sx={{ fontSize: 12, lineHeight: 1.3 }}>
        <Box sx={{ fontWeight: 500, color: 'text.primary' }}>{kolumn.visningsnamn}</Box>
        <Box sx={{ color: 'text.secondary', minHeight: '1.3em' }}>{kolumn.enhet ?? ''}</Box>
        {intervallText(kolumn) && (
          <Box
            component="span"
            sx={{
              display: 'inline-block',
              mt: 0.5,
              px: 1,
              py: 0.25,
              borderRadius: 999,
              bgcolor: 'gray200',
              color: 'text.primary',
              fontVariantNumeric: 'tabular-nums',
              whiteSpace: 'nowrap',
            }}
          >
            {intervallText(kolumn)}
          </Box>
        )}
      </Box>
    </Tooltip>
  </TableCell>
);
